/** @format */

const template = `
<ng-repeat ng-repeat="searchParameter in displayCtrl.searchParameters | filter:displayCtrl.hasValue as filteredParameters">
  <div class="search-filter-tag-holder filter-tag-holder">
    <search-filter-tag
      on-select="displayCtrl.onSelect(values, searchParameter)"
      data-cy="search-filter-tag"
      option="displayCtrl.selectableParameters[searchParameter]"
      parameter-model="displayCtrl.parameterObject(searchParameter)"
      remove-selection="displayCtrl.removeSelection(searchParameter)"
      search-parameter="searchParameter"
      search-params="displayCtrl.searchParams"
      search-again="displayCtrl.searchAgain()"
      university="displayCtrl.university"></search-filter-tag>
  </div>
</ng-repeat>
`;
export default template;
